module.exports = __webpack_public_path__ + "static/usama-6674070b6e53d69007b563804838d82e.png";